<template>
    <div class="modal modal--confirm" v-bind:class="{ 'is-open' : isOpen }">
        <div class="modal__dialog">
            <div class="modal__content">
                {{ text }}

                <nav class="modal__actions">
                    <a class="btn is-primary" v-on:click="confirm">{{ __('Confirm') }}</a>
                    <a class="btn" v-on:click="closeModal">{{ __('Cancel') }}</a>
                </nav>
            </div>
        </div>
        <div class="modal__backdrop" v-on:click="closeModal"></div>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            // attach event listeners
            eventBus.$on('open-modal', this.openModal);
        },
        data: function () {
            return {
                isOpen: false
            }
        },
        methods: {
            closeModal: function () {
                this.isOpen = false;
            },
            confirm: function () {
                eventBus.$emit('confirm', this.id);

                this.closeModal();
            },
            openModal: function (id) {
                if (this.id == id) {
                    this.isOpen = true;
                }
            }
        },
        props: {
            id: {
                required: true,
                type: [Number, String]
            },
            text: {
                required: true,
                type: String
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/elements/ConfirmModal.vue